"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maybe = void 0;
function maybe(value, transform) {
    if (value == null) {
        return undefined;
    }
    if (transform) {
        return transform(value);
    }
    return value;
}
exports.maybe = maybe;
//# sourceMappingURL=maybe.js.map